import { CatalogueGetArrivalDistrictsListParams, CatalogueGetHotelsListParams } from '@appTypes/api.types';
import { SearchOnlyHotelPackagesPaging } from '../hotels.types';

export class hotelsReset {
  static readonly type = '[Hotels] Reset';
}

export class hotelsSearchHotels {
  static readonly type = '[Hotels] SearchHotels';
  constructor(public paging?: SearchOnlyHotelPackagesPaging) {}
}

/**
 * Progressive hotel search R-PS3 (docs features/website/hotel-search-progressive.md): after `delayMs`, ask the running search
 * `pagingId` for what the suppliers brought since; repeats until the answer says searchComplete.
 */
export class hotelsPollSearchProgress {
  static readonly type = '[Hotels] PollSearchProgress';
  constructor(
    public pagingId: string,
    public delayMs: number,
    public failures = 0
  ) {}
}

export class hotelsSearchChildPackages {
  static readonly type = '[Hotels] SearchChildPackages';
  constructor(
    public parentHotelCode: string,
    public reload = false
  ) {}
}

export class hotelsGetLocations {
  static readonly type = '[Hotels] GetLocations';
  constructor(
    public params: CatalogueGetArrivalDistrictsListParams,
    public refresh = false
  ) {}
}

export class hotelsGetDestinationCountries {
  static readonly type = '[Hotels] GetDestinationCountries';
  constructor(public refresh = false) {}
}
export class hotelsGetHotels {
  static readonly type = '[Hotels] GetHotels';
  constructor(
    public params: CatalogueGetHotelsListParams,
    public refresh = false
  ) {}
}

export class hotelsResetResult {
  static readonly type = '[Hotels] hotelsResetResult';
}
